import { render, staticRenderFns } from "./PortfolioSidebar.vue?vue&type=template&id=6309b061&scoped=true"
import script from "./PortfolioSidebar.vue?vue&type=script&lang=js"
export * from "./PortfolioSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6309b061",
  null
  
)

export default component.exports